export const RESERVATIONS = 'reservations'
export const SET_DATE_FROM = `${RESERVATIONS}/SET_DATE_FROM`
export const SET_DATE_TO = `${RESERVATIONS}/SET_DATE_TO`
